import { Button, Result } from "antd";
import { useNavigate } from "react-router-dom";
import { useLogoutMutation } from "@/hooks/useAuth";

export function DeactivatedPage() {
  const navigate = useNavigate();
  const logoutMutation = useLogoutMutation();

  const handleLogout = async () => {
    try {
      await logoutMutation.mutateAsync();
    } catch {
      // ignore — localStorage всё равно почищен в onError mutation'а
    }
    navigate("/login", { replace: true });
  };

  return (
    <div style={{ padding: 64 }}>
      <Result
        status="warning"
        title="Аккаунт деактивирован"
        subTitle="Обратитесь к администратору для восстановления доступа."
        extra={
          <Button type="primary" onClick={handleLogout} loading={logoutMutation.isPending}>
            Выйти
          </Button>
        }
      />
    </div>
  );
}
